import { AxiosResponse } from 'axios';
import { makePostRequest, OkResponse } from './../helpers';

export const updateFirebaseToken = async (firebaseToken: string) => {
    const result = await makePostRequest('api/pushes/token/update', { firebaseToken });

    return result;
};

export const sendNotificationRead = async (id: number) => {
    const result: AxiosResponse<OkResponse> = await makePostRequest(`api/pushes/${id}/read`, null);

    return result.data.result.status;
};

export const sendAllNotificationsRead = async () => {
    const result: AxiosResponse<OkResponse> = await makePostRequest('api/pushes/read-all', null);

    return result.data.result.status;
};